import React from 'react';
import { Link } from 'react-router-dom';
import { Terminal } from 'lucide-react';
import { useAuth } from '../../../hooks/useAuth';
import { IntegrationLogTab } from '../../../types';

interface IntegrationLogsLinkProps {
  tab: IntegrationLogTab;
  userId?: string;
  gameProviderId?: string;
  transactionId?: string;
  className?: string;
  label?: string;
}

const IntegrationLogsLink: React.FC<IntegrationLogsLinkProps> = ({
  tab,
  userId,
  gameProviderId,
  transactionId,
  className = 'text-sm font-medium text-primary inline-flex items-center gap-1 hover:underline',
  label = 'View API logs',
}) => {
  const { hasRole } = useAuth();
  const canView = hasRole(['super_admin', 'system_admin']);

  if (!canView) return null;

  const params = new URLSearchParams({ tab });
  if (userId) params.set('userId', userId);
  if (gameProviderId) params.set('gameProviderId', gameProviderId);
  if (transactionId) params.set('transactionId', transactionId);

  return (
    <Link to={`/integration-logs?${params.toString()}`} className={className}>
      <Terminal className="h-3.5 w-3.5" />
      {label}
    </Link>
  );
};

export default IntegrationLogsLink;
